import { toast as sonnerToast } from 'sonner';

export const SKU_MAX_LENGTH = 50;

export const normalizeSku = (sku: string | null | undefined): string =>
  (sku ?? '').trim().toLowerCase();

export const skuPayload = (sku: string | undefined) =>
  sku === undefined ? {} : { sku: sku.trim() || null };

export const skuFromForm = (sku: string, skuEnabled: boolean) =>
  skuEnabled ? sku.trim() : undefined;

export const isDuplicateSkuError = (error: { code?: string; message?: string } | null | undefined): boolean =>
  error?.code === '23505' && /sku/i.test(error.message ?? '');

export const toastDuplicateSku = (translator: (key: string) => string) => {
  sonnerToast.error(translator('Products.skuAlreadyUsed'), {
    description: translator('Products.skuAlreadyUsedDescription'),
    duration: 5000,
  });
};
